<template>
  <div class="modaladmin">
    <div class="modaladmin-content">
      <div>
        IME:
        <input type="text" v-model="company.name" />
      </div>
      <div>
        OPIS:
        <input type="text" v-model="company.description" />
      </div>
      <div>
        URL:
        <input type="text" v-model="company.websiteUrl" />
      </div>
      <div>
        KATEGORIJA:
        <select v-model="company.sponsorCategory">
          <option v-bind:value="null">Nije sponzor</option>
          <option v-for="category in sponsorCategories" v-bind:value="category" v-bind:key="category">
            {{ category }}
          </option>
        </select>
      </div>
      <div>
        L. ŠTANDA:
        <input type="text" v-model="company.boothLocation" />
      </div>
      <div class="modaladmin-footer">
        <button type="button" v-bind:disabled="!company.name" v-on:click="$emit('save', company)">SPREMI</button>
        <button type="button" v-on:click="$emit('cancel', company)">ODUSTANI</button>
      </div>
    </div>
    <a aria-label="Zatvori popup" class="close-modaladmin" v-on:click="$emit('cancel', company)"></a>
  </div>
</template>

<script>
export default {
  name: 'AddEditCompanyModal',
  props: {
    company: {},
    sponsorCategories: Array,
  },
  created() {
    if (!this.company.sponsorCategory) this.company.sponsorCategory = null;
  },
};
</script>
